import PriceDropBadge from '@/vdp/Badges/PriceDropBadge';
import GreatDealBadge from './GreatDealBadge';
import NewBadge from './NewBadge';
import useBadges from './useBadges';

export default function Badges() {
  const { showBadges, showGreatDealBadge, showNewBadge, showPriceDropBadge } =
    useBadges();

  return showBadges ? (
    <div className="flex flex-wrap gap-sm">
      {showNewBadge && <NewBadge />}
      {showPriceDropBadge && <PriceDropBadge />}
      {showGreatDealBadge && <GreatDealBadge />}
    </div>
  ) : null;
}
